import {DomainEvent} from './DomainEvent';
import type {Iso8601DateString} from '@fupa/fupa-ts-core';
import type {EntityExportRequest} from './EntityExportRequest';

export interface NewsExportRequest extends EntityExportRequest {
  /** the publishing date of the news to start the export for */
  readonly from: Iso8601DateString;
  /** the publishing date of the news to end the export for */
  readonly to: Iso8601DateString;
}

/**
 * This event can be fired to indicate that a service requires published news within a specific date interval.
 * Another service that is eligible to provide this info will put batches of the requested news into
 * the specified S3 {@see NewsExportRequest.targetBucket} using
 * the {@see NewsExportRequest.transactionId} as prefix (sub-folder).
 */
export class NewsExportRequested extends DomainEvent<NewsExportRequest> {}
